<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="客户">
      {{ head.customer.customerNo }}<br />
      {{ head.customer.name }}
    </el-descriptions-item>
    <el-descriptions-item label="联系人信息" span="2">
      {{ head.customerName + " " + head.customerPhoneNumber }}
      <br />
      {{ "联系地址：" + head.customerAddress }}
    </el-descriptions-item>
    <el-descriptions-item label="定制商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="500px"
        style="max-width: 830px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="60"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  <p>商品名称：{{ scope.row.commodityName }}</p>
                  <p class="fm-mt-5">
                    备注：
                    <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
                      scope.row.remark || "——"
                    }}</span>
                  </p>
                </div>
                <div>
                  <p class="fm-line-2">
                    商品名称：{{ scope.row.commodityName }}
                  </p>
                  <p class="fm-line-2 fm-mt-5">
                    备注：
                    <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
                      scope.row.remark || "——"
                    }}</span>
                  </p>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="相关图片"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.fileList && scope.row.fileList.length > 0">
              <el-image
                v-for="(item, index) in scope.row.fileList"
                :key="index"
                :style="{
                  width: '45px',
                  height: '45px',
                  'border-radius': '5px',
                  border: '1px solid var(--fm-border-color)',
                  'margin-left': '5px',
                }"
                fit="cover"
                :preview-src-list="
                  scope.row.fileList.map(
                    (d) => d.sysFile.prefix + d.sysFile.name
                  )
                "
                :src="item.sysFile.prefix + item.sysFile.name"
              ></el-image>
            </div>
            <div class="fm-center" v-else>
              <p v-fmtype="'warning'">暂未上传</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="buyingPrice"
          label="商品零售价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.itemQuantity + scope.row.unit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="金额"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <div class="fm-flex">
                总零售价：
                <FmAmount :amount="scope.row.buyingTotalAmount"></FmAmount>
              </div>
              <div class="fm-flex">
                折扣金额：<FmAmount
                  :amount="scope.row.buyingDisCountAmount"
                ></FmAmount>
              </div>
              <div class="fm-flex">
                成交价：<FmAmount
                  :amount="scope.row.itemBuyingAmount"
                ></FmAmount>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="出入库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              待入库：{{ scope.row.toBeInputQuantity }}，入库中：{{
                scope.row.inputingQuantity
              }}
            </div>
            <div class="fm-flex">
              已入库：{{ scope.row.completedInputQuantity }}，待出库：{{
                scope.row.toBeOutputQuantity
              }}
            </div>
            <div class="fm-flex">
              出库中：{{ scope.row.outputingQuantity }}，已出库：{{
                scope.row.completedOutputQuantity
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="extFieldValueList"
          label="拓展字段"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.extFieldValueList &&
                scope.row.extFieldValueList.length > 0
              "
            >
              <div
                v-for="(item, index) in scope.row.extFieldValueList"
                :key="index"
              >
                {{
                  item.label +
                  "：" +
                  (item.value == null ? "-" : item.value) +
                  ";"
                }}
              </div>
            </div>
            <div class="fm-center" v-else>—</div>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="其他费用"
      span="4"
      v-if="
        head.otherExpenseAmount > 0 ||
        (head.orderOtherExpenseList && head.orderOtherExpenseList.length > 0)
      "
    >
      <div class="fm-flex">
        其他费用金额合计：
        <FmAmount :amount="head.otherExpenseAmount"></FmAmount>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.orderOtherExpenseList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="费用金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总零售价：<FmAmount :amount="head.buyingTotalAmount"></FmAmount
        >，优惠金额：<FmAmount :amount="head.buyingDisCountAmount"></FmAmount
        >，零售成交价：<FmAmount :amount="head.buyingAmount"></FmAmount>）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="其他成本" span="4">
      <el-tooltip slot="label" effect="dark" content="" placement="top-start">
        <div slot="content" style="line-height: 1.5em">
          <div style="font-weight: bold">其他成本说明</div>
          其他成本指商户在销售过程中除商品成本之外所需承担的各项额外费用，例如工人的安装服务费用、物流配送费用等<br />
          其他成本并不直接体现在销售单据的总金额上，而是在计算销售单的实际利润时，从单据所示金额中相应扣除的开支
        </div>
        <div class="fm-flex">
          <i class="el-icon el-icon-question fm-mr-5"></i>其他成本
        </div>
      </el-tooltip>
      <div class="fm-flex">
        <div
          class="fm-flex"
          v-if="
            head.otherCostAmount > 0 ||
            (head.orderOtherCostList && head.orderOtherCostList.length > 0)
          "
        >
          其他成本金额合计：
          <FmAmount :amount="head.otherCostAmount"></FmAmount>
        </div>
        <span v-fmtype="'warning'" v-else>——</span>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.orderOtherCostList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
        v-if="head.orderOtherCostList && head.orderOtherCostList.length > 0"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="成本金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="收款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          收款进度：
          <span
            v-fmtype="
              $jsTool.getFundCollectProgressType(head.fundCollectProgressEnum)
            "
          >
            {{ head.fundCollectProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待收：<FmAmount :amount="head.toBeCollectAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          收款中：<FmAmount :amount="head.collectingAmount"></FmAmount
          >，已收款：<FmAmount :amount="head.completedCollectAmount"></FmAmount
          >，收款优惠：<FmAmount
            :amount="head.collectDisCountAmount"
          ></FmAmount>
        </div>
        <div class="fm-flex">
          全部收款时间：<span
            v-fmtype="head.fullCollectTime ? '' : 'warning'"
            >{{ head.fullCollectTime || "暂无" }}</span
          >
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="出入库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          出入库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityInputProgressType(
                head.commodityInputProgressEnum
              )
            "
          >
            {{ head.commodityInputProgressEnum.Desc }}
          </span>
          <span
            v-fmtype="
              $jsTool.getCommodityOutputProgressType(
                head.commodityOutputProgressEnum
              )
            "
            class="fm-ml-5"
          >
            {{ head.commodityOutputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待入库：{{ head.toBeInputQuantity }}，入库中：{{
            head.inputingQuantity
          }}
        </div>
        <div class="fm-flex">
          已入库：{{ head.completedInputQuantity }}，待出库：{{
            head.toBeOutputQuantity
          }}
        </div>
        <div class="fm-flex">
          出库中：{{ head.outputingQuantity }}，已出库：{{
            head.completedOutputQuantity
          }}
        </div>
        <div class="fm-flex">
          全部出库时间：<span v-fmtype="head.fullOutputTime ? '' : 'warning'">{{
            head.fullOutputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item
      :label="
        head.fundCollectProgressEnum.Name == 'FullCollection' ||
        head.fundCollectProgressEnum.Name == 'NoNeedCollected'
          ? '单据利润'
          : '预计利润'
      "
      span="4"
      v-if="
        head.orderApprovalStatusEnum.Name == 'Approval' &&
        $jsTool.currentUserCanSeePrice()
      "
    >
      <el-tooltip slot="label" effect="dark" content="" placement="top-start">
        <div slot="content" style="line-height: 1.5em">
          <div style="font-weight: bold">定制单利润计算方式</div>
          定制单(预计)利润 = (预计)实收金额 - (预计)实付金额 - 其他成本<br />
          定制单在收付款完成前会使用预计收款金额及预计付款金额计算预计利润；<br />
          收付款完成之后，会使用实收金额及实付金额计算单据利润
        </div>
        <div class="fm-flex">
          <i class="el-icon el-icon-question fm-mr-5"></i>
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "单据利润"
              : "预计利润"
          }}
        </div>
      </el-tooltip>
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "单据利润"
              : "预计利润"
          }}：<FmAmount :amount="head.orderProfitAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "实际收款"
              : "预计实收"
          }}：
          <FmAmount
            :amount="
              $jsTool.sum([
                head.toBeCollectAmount,
                head.collectingAmount,
                head.completedCollectAmount,
                -head.collectDisCountAmount,
              ])
            "
          ></FmAmount>
        </div>
        <div class="fm-flex">
          其他成本：
          <FmAmount :amount="head.otherCostAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          采购单实付金额：
          <FmAmount
            :amount="
              $jsTool.sum([head.completedPayAmount, -head.payDisCountAmount])
            "
          ></FmAmount>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item
      label="现结金额"
      span="4"
      v-if="
        head.settledAmount > 0 ||
        (head.fundAccountList && head.fundAccountList.length > 0)
      "
    >
      <div class="fm-flex">
        现结金额合计：
        <FmAmount :amount="head.settledAmount"></FmAmount>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.fundAccountList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="fundAccount"
          label="资金账户"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              <el-image
                style="width: 18px; height: 18px"
                fit="cover"
                class="fm-margin-right-5"
                :src="
                  $jsTool.getFundAccountImageSrc(
                    scope.row.fundAccount.fundAccountTypeEnum
                  )
                "
              ></el-image>
              {{ scope.row.fundAccount.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="现结金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="收款凭证"
      span="3"
      v-if="
        head.settledAmount > 0 ||
        (head.fundAccountList && head.fundAccountList.length > 0)
      "
    >
      <OrderImageList
        :list="head.collectVoucherImageList"
        name="收款凭证图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="1">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="拓展字段" span="3">
      <div v-if="head.extFieldValueList && head.extFieldValueList.length > 0">
        <div v-for="(item, index) in head.extFieldValueList" :key="index">
          {{
            item.label + "：" + (item.value == null ? "-" : item.value) + ";"
          }}
        </div>
      </div>
      <div v-fmtype="'warning'" v-else>—</div>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizeOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = { ...newVal, headVo: newVal.head };
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.headVo
        ? this.showOrderInfo.headVo
        : {};
    },
    itemList() {
      if (this.showOrderInfo && this.showOrderInfo.itemList) {
        return this.showOrderInfo.itemList;
      }
      return [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizeOrder:NeedApproval",
        "Order:CustomizeOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.customizeOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizeOrderInfo.vue